/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { useMutation } from '@apollo/client' // Npm: Apollo client.
import { connect } from 'react-redux' // Npm: React Redux for state management.


/*
 * SIBLINGS
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import PhoneNumberoDeleteMutation from './__mutation__/index.phoneNumbero.delete.mutation'


/*
 * OBJECTS
 */
const Index = ({ passOn, onClose }) => {
  // Hook assignment.
  const [MutationPhoneNumberoDelete, MutationPhoneNumberoDeleteResponse] = useMutation(PhoneNumberoDeleteMutation)

  // Return Component.
  return (
    <DeleteCard onClose={onClose} disabled={MutationPhoneNumberoDeleteResponse.loading} onConfirm={() =>
      MutationPhoneNumberoDelete({
        'variables': {
          'phoneNumberoId': passOn?.phoneNumberoId
        }
      }).then(i => {
        // Style Guide.
        toast(i?.data?.PhoneNumberoDelete?.message)

        // Report success.
        return onClose?.()
      }).catch(() =>
        // Style Guide.
        toast('Something went wrong please try after some time.'))} isLoading={MutationPhoneNumberoDeleteResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
